import { Box, IconButton } from "@mui/material";

import MainText from "../MainText";

type ComponetProps = {
  size?: "title" | "subtitle";
  title: string;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  onLeftAction?: () => void;
  onRightAction?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function PageHeader({
  size = "title",
  title,
  leftIcon,
  rightIcon,
  onLeftAction,
  onRightAction,
  ...props
}: ComponetProps) {
  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
      }}
    >
      <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {leftIcon && (
          <Box color={"black"}>
            <IconButton
              color="inherit"
              onClick={onLeftAction}
              sx={{
                marginRight: "5px",
                "& .MuiSvgIcon-root": {
                  fontSize: "32px",
                },
              }}
            >
              {leftIcon}
            </IconButton>
          </Box>
        )}
        <MainText size={size} color="black">
          {title}
        </MainText>
      </Box>

      {rightIcon && (
        <Box color={"black"}>
          <IconButton
            color="inherit"
            onClick={onRightAction}
            sx={{
              marginLeft: "5px",
              "& .MuiSvgIcon-root": {
                fontSize: "32px",
              },
            }}
          >
            {rightIcon}
          </IconButton>
        </Box>
      )}
    </Box>
  );
}
